export default __webpack_public_path__ + "static/media/BlackFrame06.481e509e.png";